import { Heading } from '@alefeducation/ui-elements-library-core';
import React from 'react';
import styled from 'styled-components';
import { usePermissionCategoryContext } from './PermissionCategoryContext';
import { rowStyles } from './common.styled';

const StyledListItem = styled.div`
  ${rowStyles};
  margin-bottom: 16px;
`;

const AssignedPermissionList = () => {
  const { assignedPermissions } = usePermissionCategoryContext();

  return (
    <React.Fragment>
      {assignedPermissions.map(({ permission, module }, i: number) => (
        <StyledListItem key={i}>
          <Heading variant="heading-small" weight="light" color="primary.100">
            {permission}
          </Heading>
          <Heading variant="heading-small" weight="light" color="primary.100">
            {module}
          </Heading>
        </StyledListItem>
      ))}
    </React.Fragment>
  );
};

export default AssignedPermissionList;
